import { ReactNode } from 'react';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

const CONTENT_MIN_HEIGHT = 222;
const CORE_MESSAGE_MIN_HEIGHT = 150;

interface InfoCarouselStepContentProps {
  title: string;
  body: string;
  footer?: ReactNode;
  width: number;
  height: number;
  onIllustrationLayout: (event: LayoutChangeEvent) => void;
}

const InfoCarouselStepContent = ({
  title,
  body,
  footer,
  width,
  height,
  onIllustrationLayout,
}: InfoCarouselStepContentProps) => (
  <View style={{ width, height }}>
    <View style={styles.illustration} onLayout={onIllustrationLayout} />
    <View style={styles.content}>
      <View style={styles.coreMessage}>
        <TitleLgText accessibilityRole="header" numberOfLines={0}>
          {title}
        </TitleLgText>
        <BodyBaseText numberOfLines={0}>{body}</BodyBaseText>
      </View>
      {footer ? <View style={styles.footer}>{footer}</View> : null}
    </View>
  </View>
);

const styles = StyleSheet.create({
  content: {
    minHeight: CONTENT_MIN_HEIGHT,
  },
  coreMessage: {
    gap: theme.spacing.s,
    minHeight: CORE_MESSAGE_MIN_HEIGHT,
    padding: theme.spacing.m,
  },
  footer: {
    padding: theme.spacing.m,
  },
  illustration: {
    flex: 1,
  },
});

export default InfoCarouselStepContent;
